<template>
    <div class="absolute-notification-small is-active" v-if="show">
        <div class="notification">
            <div class="m-b-20 text-left">
                <strong>{{ $t('cookieConsent.request.title') }}</strong>
                <p>{{ $t('cookieConsent.request.description') }}</p>
            </div>
            <div class="actions d-flex flex-column flex-sm-row">
                <button @click="acceptAll" class="button button--small m-r-10--sm">{{ $t('cookieConsent.request.accept') }}</button>
                <button @click="customizePreferences" class="button button--small button--text m-t-10 m-t-0--sm">{{ $t('cookieConsent.request.settings') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import {ref} from 'vue';
import ConsentManager from "../consent/ConsentManager";

export default {
    name: 'ConsentRequest',
    setup() {
        const show = ref(true);
        const consent = ref(ConsentManager.consentTypes);

        return {
            show,
            consent,
        };
    },
    // Define method that calls onConsentChange function
    methods: {
        acceptAll() {
            // Loop through all consent types and set them to 'granted'
            for (const key in this.consent) {
                this.consent[key] = 'granted';
            }

            // Set consent through the ConsentManager
            ConsentManager.onConsentChange(this.consent);

            // Hide the notification
            this.show = false;
        },
        customizePreferences() {
            this.show = false;

            // Show the preferences modal
            ConsentManager.showConsentPreferences();
        },
    },

}
</script>

<style scoped>
.notification {
    font-size: 1.6rem;
    line-height: 1.7;

    strong {
        font-size: 1.7rem;
        line-height: 2;
    }

    p {
        color: #6A6A6A;
    }
}
</style>
